<template>
  <div class="game">
    <div class="h-banner">
      <div class="container">
        <h1>云游戏解决方案</h1>
        <div class="row">
          <p class="col-sm-7">助力手机/PC游戏快速进入云游戏时代<br/>提供高性价比的GPU IAAS解决方案</p>
        </div>
      </div>
    </div>
    <div class="session-1">
      <div class="container">
        <div class="row"><div class="caption">方案优势</div></div>
        <ul class="row">
          <li class="col-md-3">
            <div class="li-wrap">
              <img src="@/assets/images/scheme/r_game_icon_01.png" alt="">
              <p>高速接入，快速部署</p>
            </div>
          </li>
          <li class="col-md-3">
            <div class="li-wrap">
              <img src="@/assets/images/scheme/r_game_icon_02.png" alt="">
              <p>无需下载，一键启动</p>
            </div>
          </li>
          <li class="col-md-3">
            <div class="li-wrap">
              <img src="@/assets/images/scheme/r_game_icon_03.png" alt="">
              <p>渲染算力强劲，支持高并发</p>
            </div>
          </li>
          <li class="col-md-3">
            <div class="li-wrap">
              <img src="@/assets/images/scheme/r_game_icon_04.png" alt="">
              <p>跨平台，无终端限制</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="session-2">
      <div class="container">
        <div class="row"><div class="caption">技术架构</div></div>
        <div class="row">
          <div class="picture col-sm-6">
            <img src="@/assets/images/scheme/r_game_images_01.png" alt="">
          </div>
          <div class="introduce col-sm-6">
            <div class="title">一体化云游戏技术架构</div>
            <p>游戏运行于云端GPU服务器，只要有网络就可以通过各种终端设备连接和使用云游戏，类似远程桌面一样控制它。云游戏解决方案融合GPU/CPU以及CDN，实时传输能力，实时编码、实时通讯、实时渲染。多样的音视频分发互动方案，支持多人直播等。跨平台服务和多屏互动，终端侧多形态覆盖。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="session-3">
      <div class="container">
        <div class="row"><div class="caption">应用场景</div></div>
        <div class="row">
          <ul>
            <li class="col-md-3 col-sm-6 col-xs-6">
              <img src="@/assets/images/scheme/r_game_images_02.png" alt="">
              <div class="txt">PC云游戏</div>
            </li>
            <li class="col-md-3 col-sm-6 col-xs-6">
              <img src="@/assets/images/scheme/r_game_images_03.png" alt="">
              <div class="txt">手机云游戏</div>
            </li>
            <li class="col-md-3 col-sm-6 col-xs-6">
              <img src="@/assets/images/scheme/r_game_images_04.png" alt="">
              <div class="txt">主机云游戏</div>
            </li>
            <li class="col-md-3 col-sm-6 col-xs-6">
              <img src="@/assets/images/scheme/r_game_images_05.png" alt="">
              <div class="txt">模拟器云游戏</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.h-banner{
  background: #282839;
  color: #fff;
  h1{
    font-size: 36px;
    font-weight: bold;
    margin-top: 70px;
  }
  p{
    font-size: 18px;
    color: #A2A2BB;
    margin-top: 20px;
    margin-bottom: 70px;
  }
}
.caption{
  margin-top: 80px;
}
@media (max-width: $screen-sm-min) {
  .caption{
    margin-top: 40px;
  }
}
.session-1{
  .caption{
    margin-bottom: 10px;
  }
  ul{
    li{
      margin-top: 30px;
      .li-wrap{
        border: 1px solid #CFCFCF;
        padding-top: 30px;
        padding-bottom: 20px;
        img{
          display: block;
          width: 42px;
          height: 42px;
          margin: 0 auto;
        }
        p{
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-top: 18px;
        }
      }
    }
  }
}
.session-2{
  .picture{
    img{
      width: 100%;
      max-width: 654px;
      display: block;
    }
  }
  .introduce{
    .title{
      font-size: 24px;
      font-weight: bold;
      margin-top: 50px;
    }
    p{
      font-size: 14px;
      margin-top: 35px;
    }
  }
}
@media (max-width: $screen-sm-min) {
  .session-2{
    .introduce{
      p{
        margin-top: 20px;
      }
    }
  }
}
.session-3{
  margin-bottom: 120px;
  .container{
    .caption{
      margin-bottom: 10px;
    }
    ul{
      li{
        position: relative;
        margin-top: 30px;
        img{
          display: block;
          width: 100%;
        }
        .txt{
          font-size: 32px;
          font-weight: bold;
          color: #fff;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 32px;
          text-align: center;
        }
      }
    }
  }
}
@media (max-width: $screen-sm-min) {
  .session-3{
    margin-bottom: 40px;
    .container{
      ul{
        li{
          .txt{
            font-size: 24px;
          }
        }
      }
    }
  }
}
</style>
